import { DetailGroups, Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { createAction, props } from '@ngrx/store';

export const getGroup = createAction('[GROUP] get Group ');
export const getGroupSuccess = createAction(
	'[GROUP] get Group success',
	props<{ group: Groups[] }>()
);
export const getGroupError = createAction('[GROUP] get Group error', props<{ error: any }>());

export const getAllGroup = createAction('[GROUP] get All Group ');
export const getAllGroupSuccess = createAction(
	'[GROUP] get All Group success',
	props<{ groups: Groups[] }>()
);
export const getAllGroupError = createAction(
	'[GROUP] get All Group error',
	props<{ error: any }>()
);

export const postGroup = createAction('[GROUP] Post Group', props<{ group: Groups }>());
export const postGroupSuccess = createAction(
	'[GROUP] post Group success',
	props<{ group: Groups }>()
);
export const postGroupError = createAction('[GROUP] post Group error', props<{ error: any }>());

export const updateGroup = createAction(
	'[GROUP] Update Group',
	props<{ group: Groups; ids: IPkSk }>()
);
export const updateGroupSuccess = createAction(
	'[GROUP] Update Group success',
	props<{ group: Groups }>()
);
export const updateGroupError = createAction('[GROUP] Update Group error', props<{ error: any }>());

export const createStatusGroup = createAction(
	'[GROUP] Create Status Selected Group',
	props<{ group: Groups; ids: IPkSk }>()
);
export const createStatusGroupSuccess = createAction(
	'[GROUP] Create Status Selected Group success',
	props<{ group: Groups }>()
);
export const createStatusGroupError = createAction(
	'[GROUP] Create Status Selected Group error',
	props<{ error: any }>()
);

export const deleteStatusGroup = createAction(
	'[GROUP] Delete Status Selected Group',
	props<{ group: Groups; ids: IPkSk }>()
);
export const deleteStatusGroupSuccess = createAction(
	'[GROUP] Delete Status Selected Group success',
	props<{ group: Groups }>()
);
export const deleteStatusGroupError = createAction(
	'[GROUP] Delete Status Selected Group error',
	props<{ error: any }>()
);

export const updateStatusGroup = createAction(
	'[GROUP] Update Status Selected Group',
	props<{ group: Groups; ids: IPkSk }>()
);
export const updateStatusGroupSuccess = createAction(
	'[GROUP] Update Status Selected Group success',
	props<{ group: Groups }>()
);
export const updateStatusGroupError = createAction(
	'[GROUP] Update Status Selected Group error',
	props<{ error: any }>()
);

export const updateSelectedGroup = createAction(
	'[GROUP] Update Selected Group',
	props<{ group: Groups; ids: IPkSk }>()
);
export const updateSelectedGroupSuccess = createAction(
	'[GROUP] Update Selected Group success',
	props<{ group: Groups }>()
);
export const updateSelectedGroupError = createAction(
	'[GROUP] Update Selected Group error',
	props<{ error: any }>()
);

export const getDetailGroups = createAction('[GROUP] get detail groups ', props<{ url: string }>());
export const getDetailGroupsSuccess = createAction(
	'[GROUP] get detail groups success',
	props<{ detailGroups: DetailGroups }>()
);
export const getDetailGroupsError = createAction(
	'[GROUP] get detail groups error',
	props<{ error: any }>()
);

export const getSubGroups = createAction(
	'[GROUP] get subGroups',
	props<{ pk: string; sk: string }>()
);
export const getSubGroupsSuccess = createAction(
	'[GROUP] get subGroups success',
	props<{ group: Groups[] }>()
);
export const getSubGroupsError = createAction(
	'[GROUP] get subGroups error',
	props<{ error: any }>()
);

export const deleteGroup = createAction('[GROUP] Delete Group', props<{ ids: IPkSk }>());
export const deleteGroupSuccess = createAction(
	'[GROUP] Delete Group success',
	props<{ ids: Groups }>()
);
export const deleteGroupError = createAction('[GROUP] Delete Group error', props<{ error: any }>());

export const getUsersGroups = createAction(
	'[GROUP] Get users groups',
	props<{ group: IPkSk; paginationTo?: number }>()
);
export const getUsersGroupsSuccess = createAction(
	'[GROUP] Get users groups success',
	props<{ user: UsersGroups[]; pagination: Pagination }>()
);
export const getUsersGroupsError = createAction(
	'[GROUP] Get users groups error',
	props<{ error: any }>()
);

export const searchUsersGroups = createAction(
	'[GROUP] Search users groups',
	props<{ group: IPkSk; url: string }>()
);
export const searchUsersGroupsSuccess = createAction(
	'[GROUP] Search users groups success',
	props<{ user: UsersGroups[]; pagination: Pagination }>()
);
export const searchUsersGroupsError = createAction(
	'[GROUP] Search users groups error',
	props<{ error: any }>()
);

export const postUsersGroups = createAction(
	'[GROUP] Post users groups',
	props<{ user: UsersGroups }>()
);
export const postUsersGroupsSuccess = createAction(
	'[GROUP] Post users groups success',
	props<{ user: UsersGroups }>()
);
export const postUsersGroupsError = createAction(
	'[GROUP] Post users groups error',
	props<{ error: any }>()
);

export const updateUsersGroups = createAction(
	'[GROUP] Update users groups',
	props<{ user: UsersGroups; idsUser: IPkSk }>()
);
export const updateUsersGroupsSuccess = createAction(
	'[GROUP] Update users groups success',
	props<{ user: UsersGroups }>()
);
export const updateUsersGroupsError = createAction(
	'[GROUP] Update users groups error',
	props<{ error: any }>()
);

export const deleteBulkUsersGroups = createAction(
	'[GROUP] Delete Bulk users groups',
	props<{ user: string[]; ids: IPkSk }>()
);
export const deleteBulkUsersGroupsSuccess = createAction(
	'[GROUP] Delete Bulk users groups success',
	props<{ user: UsersGroups[] }>()
);
export const deleteBulkUsersGroupsError = createAction(
	'[GROUP] Delete Bulk users groups error',
	props<{ error: any }>()
);
